//src/api/formaciones.ts
import api from "./axios";

export type CrearFormacionPayload = {
  idAsignatura: number;
  idProfesor: number; // profesor a formar
  idFormador: number; // profesor que forma
  fechaLimite: string;
};

export async function postFormacion(payload: CrearFormacionPayload) {
  const { data } = await api.post("/formaciones/solicitar", payload);
  return data;
}
export async function asignarFormador(payload: { userId: number; tipoIds: number[] }) {
  const { data } = await api.post("/formaciones/asignar-formador", payload);
  return data;
}
